import { render, staticRenderFns } from "./DescargadorCaf.vue?vue&type=template&id=f3cf43b6"
import script from "./DescargadorCaf.vue?vue&type=script&lang=js"
export * from "./DescargadorCaf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports